/** Shared confidence-level ordering for sorting topics and gap suggestions. */
export const CONFIDENCE_ORDER: Record<string, number> = {
    high: 0,
    medium: 1,
    low: 2,
};
